import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import Pane from 'components/Common/Pane'
import LayoutContainer from 'components/Common/LayoutContainer'
import { mediaQueryUp } from 'components/utils/breakpoint'
import CruisePriceRoomTypeInfo, { PriceRoomTypeProps } from './CruisePriceRoomTypeInfo'
import Heading from 'components/Luxkit/Typography/Heading'
import cn from 'clsx'
import zIndex from 'styles/tools/z-index'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import TabButton from 'components/Luxkit/Tabs/TabButton'
import TabButtonsGroup from 'components/Luxkit/Tabs/TabButtonsGroup'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Group from 'components/utils/Group'
import { CruiseSectionTabValues } from 'constants/cruise'

const NavWrapper = styled(Pane)`
  position: fixed;
  width: 100vw;
  z-index: ${zIndex.subHeader};
  top: 0;
  transition: transform 500ms ease-in-out;
  box-shadow: ${props => props.theme.shadow.bottom.small};
  /* Move offscreen by an extra 10px so the shadow isn't visible when header is hidden */
  display: none;
  transform: translateY(calc(-100% - 10px));

  &.visible {
    transform: translateY(0);
  }
  ${mediaQueryUp.sm} {
    display:unset;
  }

`

const Inner = styled(LayoutContainer)`
  width: 100%;
  justify-content: start;
  padding: 0;
`
const TabsContainer = styled(VerticalSpacer)`
  padding-top: ${rem(16)};
`

type SECTION_TABS = {
  label: string;
  value: CruiseSectionTabValues;
}[]

interface Props extends PriceRoomTypeProps {
  visible: boolean
  title: string
  tabs: SECTION_TABS
  currentSectionTab: CruiseSectionTabValues
  handleTabsChange: (tab: CruiseSectionTabValues) => void
}

function CruiseStickyHeader(props: Props) {
  const { visible, onView, priceFrom, title, handleTabsChange, currentSectionTab, tabs } = props
  return (
    <NavWrapper className={cn({ visible })} shadow data-testid="tour-v2-sticky-header" >
      <Inner>
        <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="center">
          <TabsContainer gap={4}>

            <Heading variant="heading5" colour="neutral-one" >{title}</Heading>
            <LayoutContainer>
              <TabButtonsGroup fit="auto">
                {tabs.map((tab) => (
                  <TabButton
                  size="medium"
                  key={tab.value}
                  isActive={tab.value === currentSectionTab}
                  onClick={() => {
                    handleTabsChange(tab.value)
                    onView(tab.value)
                  }}>{tab.label}</TabButton>
                ))}
              </TabButtonsGroup>
            </LayoutContainer>
          </TabsContainer>
          <CSSBreakpoint min="sm">
            <CruisePriceRoomTypeInfo priceFrom={priceFrom} onView={onView} header />
          </CSSBreakpoint>
        </Group>
      </Inner>
    </NavWrapper>
  )
}
export default CruiseStickyHeader
